import {api} from '../../utils/api'

export default {
    /**
     * get all positions
     * @param commit
     * @param task_id
     * @returns {*|Promise|Promise<any>}
     */
    loadPositions({commit}, task_id) {
        return api.call(commit, 'get', '/api/positions/'+task_id, null, 'SET_POSITIONS');
    },

    /**
     * Register new position
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    register({ commit }, payload) {

        // Call register
        return api.call(commit, 'post', '/api/positions', payload, 'SET_POSITIONS');
    },

    /**
     * Update position
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    update({ commit }, payload) {

        // Call register
        return api.call(commit, 'patch', '/api/positions/'+payload.id, payload, 'SET_POSITIONS');
    },

    /**
     * Update user on position
     * @param commit
     * @param position_id
     * @param user_id
     * @param payload
     * @returns {Promise<any>}
     */
    addUserToPos({ commit }, {position_id, user_id}) {
        // Call store user
        return api.call(commit, 'post', '/api/positions/'+ position_id + '/user', {user_id}, 'SET_POSITIONS');
    },

    /**
     * Delete user on position
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    deleteUserOnPos({ commit }, payload) {
        // Call delete
        return api.call(commit, 'delete', '/api/positions/'+payload.id + '/user/'+payload.user_id, payload, 'SET_POSITIONS');
    },

    /**
     * Delete position
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    delete({ commit }, payload) {

        // Call register
        return api.call(commit, 'delete', '/api/positions/'+payload.id, payload, 'DELETE_POSITIONS');
    },

}
